// extracted by mini-css-extract-plugin
export default {"professionColor":"styles_professionColor__NePmT","tooltipContainer":"styles_tooltipContainer__0jPWs","bottomPart":"styles_bottomPart__Vj7v7","bottomItem":"styles_bottomItem__ao8Vn"};